﻿import {Component, Input, Output, EventEmitter, ViewContainerRef} from "@angular/core";
import {TextBoxBase} from "./textBoxBase";

@Component({
    selector: "jax-textbox",
    inputs: ["label","showLabel", "isDisabled", "type","id", "inputValue",  "propertyName", "propertyDisplayName", "validate", "validators", "maxLength", "isReadOnly", "autocomplete"],
    templateUrl: "./textBox.component.html"
})
export class TextBoxComponent extends TextBoxBase {

    public label: string;
    public autocomplete = "on";
    public showLabel: string = "true";

    private inputLabel: string;
    @Output() inputValueChange: any = new EventEmitter();
    @Output() Keytab: any = new EventEmitter();
    @Input() isMandatory :boolean;


    constructor(elemRef: ViewContainerRef) {
        super(elemRef);
    }


    public updateValue(event) {
        this.inputValue = event;
        this.inputValueChange.emit(event);
    }

    public KeyTab(event) {
        this.Keytab.emit(event);
    }

    public ngOnInit() {
    }

    public ngOnDestroy() {
        this.dispose();
    }
}
